module.exports = __webpack_public_path__ + "img/15.d39cb819.png";